import React from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CreateIcon from "@mui/icons-material/Create";
import { useNavigate } from 'react-router-dom';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue, red } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import AttachmentIcon from '@mui/icons-material/Attachment';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Grid } from '@mui/material';
import FormikControl from '../../FormikControl';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 10,
  p: 3,
};
function CustomTabPanel(props) {

  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function MobileComplains() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openSort = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseSort = () => {
    setAnchorEl(null);
  };

  const initialValues = {
    complain_title: "",
    description: "",
  };

  const validationSchema = Yup.object({
    complain_title: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);

  return (
    <div className='MainView'>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/Apartment")}
        />
        <h1>Complaints</h1>
    </div>
    <div className='topSpace'></div>
    <div className='tabView'>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Open Complaints" {...a11yProps(0)} style={{width:'50%'}}/>
          <Tab label="Close Complaints" {...a11yProps(1)} style={{width:'50%'}}/>
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={openSort ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openSort ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openSort}
          onClose={handleCloseSort}
          onClick={handleCloseSort}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleCloseSort}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleCloseSort}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
        <div className="detailsDiMob" onClick={() => navigate("/MobileComplainDetails")}>
          <h1>Demo text</h1>
          <div className="mobWithIco">
            <p>12/10/2024</p>
          </div>
        </div>
        <div className="listDeleEdiMob">
          <CreateIcon style={{ color: "#21bd21" }} />
          <DeleteOutlineIcon style={{ color: "#ff5252" }} />
        </div>
        </div>
        <div className="famDetailsListBot">
          <p>
            <span>Description Description Description Description Description Description</span>
          </p>
          <p>
            <span>Complain No:- 101</span>
          </p>
          <p>
            <span>Complaints Status: Open</span>
          </p>
        </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={openSort ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openSort ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openSort}
          onClose={handleCloseSort}
          onClick={handleCloseSort}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleCloseSort}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleCloseSort}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
        <div className="detailsDiMob">
          <h1>Demo text</h1>
          <div className="mobWithIco">
            <p>12/10/2024</p>
          </div>
        </div>
        <div className="listDeleEdiMob">
          <div>
          <button type="button" className='btnReopen'>Reopen</button>
          </div>
        </div>
        </div>
        <div className="famDetailsListBot">
          <p>
            <span>Description Description Description Description Description Description</span>
          </p>
          <p>
            <span>Complain No:- 101</span>
          </p>
          <p>
            <span>Complaints Status: Close</span>
          </p>
        </div>
        </div>
      </CustomTabPanel>
      </Box>
    </div>
    <div className='flaotBtnAdd'>
      <Fab size="medium" sx={{backgroundColor: '#3853ec'}} aria-label="add" onClick={handleOpen}>
        <AddIcon sx={{fontSize: 32, color:'white'}}/>
      </Fab>
    </div>
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Lodge Complaint</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
          {(formik) => (
            <Form>
          <div className='FormView'>
          <Grid item xs={12} md={12}>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Complaint Title"
              placeholder="Enter Title"
              labelclassName="inputLebal"
              name="complain_title"
              className="titleInput"
            />
            </div>
          </Grid>  
            <div className='lebalInputView'>
            <FormikControl
              control="textarea"
              type="text"
              label="Description"
              placeholder="Enter description"
              labelclassName="inputLebal"
              name="description"
              className="textAreaInput"
            />
            </div>
            <div className='checkBoxView'>
              <input type='checkbox' className='checkBoxStyle' />
              <p className='checkBoxTxt'>This is urgent</p>
            </div>
            <div className='attchmentView'>
              <AttachmentIcon sx={{ fontSize: 30, color: '#3853ec' }} />
              <input type='file' className='fileUploadButton'/>
              <p className='checkBoxTxt'>Attachment</p>
            </div>
            <div className='attchmentView'>
              <p className='fileName'>File name</p>
              <CloseIcon sx={{ color: red[600], fontSize: 25 }} />
            </div>
            <button className='submitButton' type='submit'>Submit</button>
          </div>
          </Form>
            )}
          </Formik>
        </Box>
    </Modal>
    </div>
  )
}

export default MobileComplains